import { useState, useEffect } from 'react';
import { NetworkError } from '@CS/components/Popups';

export default () => {
  const [onLine, setOnLine] = useState(false);
  const checkConnection = () => setOnLine(navigator.onLine);

  useEffect(() => {
    checkConnection();
    window.addEventListener('online', checkConnection);
    window.addEventListener('offline', checkConnection);

    return () => {
      window.removeEventListener('online', checkConnection);
      window.removeEventListener('offline', checkConnection);
    };
  }, []);

  return !onLine && <NetworkError onRetry={checkConnection} />;
};
